export default {
    configuration: true,
    'searchList': {
        'searchTxt': [
            {
                'name': '排单编号',
                'value': 'lineCode',
                'type': 'input',
                'unfold': true,
                'span': 2
            },
            {
                'name': '车次号',
                'value': 'trainNum',
                'type': 'input',
                'unfold': true,
                'span': 2
            },
            {
                'name': '发车单号',
                'value': 'dispatchNo',
                'type': 'input',
                'unfold': true,
                'span': 2
            },
            {
                'name': '服务平台',
                'value': 'siteName',
                'unfold': true,
                'type': 'advance',
                'advanceConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '名称' },
                    { 'prop': 'escoCompanyNo', 'value': '编码' }
                ],
                'tableConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '平台名称' },
                    { 'prop': 'escoCompanyNo', 'value': '平台编码' }
                ],
                'advanceUrl': '/searchPlatform',
                'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                'span': 3
            },
            {
                'name': '分公司',
                'value': 'companyName',
                'unfold': true,
                'type': 'advance',
                'advanceConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '分公司名称' },
                    { 'prop': 'escoCompanyNo', 'value': '分公司编码' }
                ],
                'tableConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '分公司名称' },
                    { 'prop': 'escoCompanyNo', 'value': '分公司编码' }
                ],
                'advanceUrl': '/searchBrand',
                'cbParams': ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode'],
                'span': 3
            },
            {
                'name': '客户订单号',
                'value': 'customerOrderNo',
                'type': 'input',
                'unfold': true,
                'span': 2
            },
            {
                'name': '状态',
                'value': 'dispatchStatusList',
                'type': 'select',
                'multiple': true,
                'optionNum': 'TRAIN_STATUS',
                'options': [],
                'unfold': true,
                'span': 3
            },
            {
                'name': '创建时间',
                'value': 'createTime',
                'startTime': 'startCreateTime',
                'endTime': 'endCreateTime',
                'startPlaceholder': '创建开始日期',
                'endPlaceholder': '创建结束日期',
                'type': 'time',
                'timeNum': 3,
                'unfold': true,
                'span': 5
            }
        ],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table': {
        'clickModify': true,
        'selectBtn': true,
        'leftWidth': 80,
        'height': '400px',
        leftOperation: true,
        'action': [
            {
                'type': 'text',
                'label': '排车',
                'size': 'small',
                'event': 'arrange',
                'ifHas': 'otp02020008'
            }
        ],
        'columns': [
            {
                'label': '状态',
                'prop': 'dispatchStatusName',
                'width': 80,
                'sort': true
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                'width': 140,
                'sort': true
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'width': 140,
                'sort': true
            },
            {
                'label': '车次号',
                'prop': 'trainNum',
                'type': 'button',
                'width': 140,
                'sort': true
            },
            {
                'label': '发车单号',
                'prop': 'dispatchNo',
                'width': 160,
                'sort': true
            },
            {
                'label': '订单数',
                'prop': 'orderNum',
                'width': 100,
                'sort': true
            },
            {
                'label': '方数（m³）',
                'prop': 'volume',
                'width': 120,
                'sort': true
            },
            {
                'label': '里程（km）',
                'prop': 'mileage',
                'width': 120,
                'sort': true
            },
            {
                'label': '串点数',
                'prop': 'pointNum',
                'width': 110,
                'sort': true
            },
            {
                'label': '方数装载率',
                'prop': 'volumeRates',
                'width': 130,
                'sort': true
            },
            {
                'label': '排单编号',
                'prop': 'lineCode',
                'width': 200,
                'sort': true
            },
            {
                'label': '采购渠道',
                'prop': 'procurementChannelName',
                'width': 100,
                'sort': true
            },
            {
                'label': '车辆信息',
                'prop': 'vehicleCardAndEquipmentName',
                'width': 180,
                'sort': true
            },
            {
                'label': '司机信息',
                'prop': 'driverAndDriverContactWay',
                'width': 120,
                'sort': true
            },
            {
                'label': '推荐车型',
                'prop': 'truckModel',
                'width': 120,
                'sort': true
            },
            {
                'label': '核载方数（m³）',
                'prop': 'truckMaxVolume',
                'width': 140,
                'sort': true
            },
            {
                'label': '创建人',
                'prop': 'createUserName',
                'width': 100,
                'sort': true
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': 160,
                'sort': true
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next',
        'pageSize': 10,
        'pageSizes': [
            10,
            20,
            30,
            50
        ]
    }
};
